import React          from 'react';
import colors         from '../../utils/colors';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        transform:      'translate(0px, -10px)',
        transition:     'all 0.3s',
    },
    unit: {
        height:         70,
        width:          70,
        marginLeft:     10,
        marginRight:    10,
        fontSize:       30,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        color:          colors.blue,
        border:         `1px solid ${ colors.blue }`,
        borderRadius:   '0.5em',
        transition:     'all 0.3s',
        cursor:         'default'
    }
    
}))

type TextProps = {
    text:        string[];
    showAnswer:  boolean;
}

const Text: React.FC<TextProps> = ({ 
    text,
    showAnswer,
 }) => {

 const classes = useStyles();


  return (
        <div className = { classes.root }>
           { 
             text.map((val, ind) => {
                 return(
                    <div 
                       key       = { `text&&&&&_${ ind }` }
                       className = { classes.unit }
                    >
                      { ind === 4 && !showAnswer ? '?' : val }
                    </div>
                 )
             }) 
           }
        </div>
  );
}



export default Text;








